var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer z-flex z-flex-center"},[_c('div',{staticClass:"copyright"},[_vm._v("©2019 福州全摄汇网络科技有限公司版权所有"),_c('br'),_vm._v("闽ICP备19009816号-2 ")])])
}]

export { render, staticRenderFns }